import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Capacitor } from '@capacitor/core';

import { Observable } from 'rxjs';

/**
 * Tells the API where the app runs: `ios` or `android` for the store apps,
 * `web` when the same build is opened in a browser. The API uses it on
 * `/me/profile` to count web connections apart from native ones.
 */
@Injectable()
export class PlatformInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    req = req.clone({
      setHeaders: {
        'X-Platform': Capacitor.getPlatform()
      }
    });
    return next.handle(req);
  }
}
